// extracted by mini-css-extract-plugin
module.exports = {"link":"background_link__wXQ3j"};